import { useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { FormCloudEnvironment } from "~/models/Commons ";
import {
  useSaveCloudEnvironmentMutation,
  useUpdateCloudEnvironmentMutation,
} from "~/services/cloudenvironment";
import { useGetProvidersQuery } from "~/services/providers";


export const UseFormCloudEnvironment = (refetch: () => void,id?: number) => {
  const navigate = useNavigate();
  const isSubmittingRef = useRef(false);
   const { data: provider } = useGetProvidersQuery();
  const [saveCloudEnvironment, { isLoading: isSaving, isError }] =
    useSaveCloudEnvironmentMutation();

  const [updateCloudEnvironment, { isLoading: isUpdating }] =
    useUpdateCloudEnvironmentMutation();

 

  const {
    formState: { errors, isValid, isSubmitting },
    handleSubmit,
    control,
    reset,
    setValue,
    watch
  } = useForm<FormCloudEnvironment>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      environmentName: "",
      environmentDescription: null,
      datacenterName: "",
      datacenterDescription: null,
      location: "",
      cloudProviderId: null,
      iac: "",
      authenticationConfig: "",
    },
  });

  const parseFormData = (data: FormCloudEnvironment): FormCloudEnvironment => ({
    ...data,
    cloudProviderId: data.cloudProviderId?.value,
  });


  //Create
  const submitForm = async (data: FormCloudEnvironment) => {
    if (isSubmittingRef.current || isSaving) return;

    isSubmittingRef.current = true;
    try {
      const response = await saveCloudEnvironment(
        parseFormData(data)
      ).unwrap();

      navigate("/cloud-environment",{state: { success: response.success,
        response: response }});
    } catch (error: any) {
       navigate("/cloud-environment",{state: { error: error}});
    } finally {
       refetch();
      isSubmittingRef.current = false;
    }
  };

  // Update
  const updateForm = async (data: FormCloudEnvironment) => {
    if (!id) {
      return;
    }

    if (isSubmittingRef.current || isUpdating) return;

    isSubmittingRef.current = true;
    try {
      const response = await updateCloudEnvironment({
        id,
        data: parseFormData(data),
      }).unwrap();

      navigate("/cloud-environment",{state: { success: response.success,
        response: response }});
    } catch (error: any) {
       navigate("/cloud-environment",{state: { error: error}});
    } finally {
        refetch();
      isSubmittingRef.current = false;
    }
  };

  return {
    watch,
    handleSubmit,
    control,
    errors,
    isValid,
    isSubmitting,
    submitForm,
    updateForm,
    provider,
    isLoading: isSaving || isUpdating,
    isError,
    reset,
    setValue,
    id,
  };
};
